import React from 'react'
import {Box,Card,Typography} from '@mui/material'
export default function BankCard({icon, name,color}) {
  return (
    <Card sx={{width:{xs:"300px",md:"400px"},height:"200px",display:"flex",alignItems:"center",justifyContent:"space-around",margin:"2vh 5vw"}} elevation={10}>
        <Box component="img" src={icon} width="100px"></Box>
        <Typography variant="h4" color={color}>{name}</Typography>
    </Card>
  )
}
